import React, { Component } from 'react';
import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import HtmlSection from './htmlsection';
import * as wActs from '../actions/website-actions';


class SideBanners extends Component {


  render() {
    let rep = this.props.Repeat;
    let cde = <HtmlSection key={this.props.Id + "Single"} Id={this.props.Id} />;
    let cdes=[]; let dCdes = false;
    if(!wActs.isNullOrUndefined(rep)) {
      rep = parseInt(rep);
      dCdes=true;
      for(let x=1; x<=rep; x++) {
        cdes.push(<p key={this.props.Id + "-p-" + x} style={{color: 'transparent', margin: '0px', marginBottom: '15px', padding: '0px'}}><HtmlSection key={this.props.Id + "-" + x} Id={this.props.Id} /></p>);
      }
    }
    return (
      <div>
        <div className={this.props.Classnames}>
          {dCdes && <span>{cdes}</span>}
          {!dCdes && <span>{cde}</span>}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Name: state.Website.Name,
    Domain: state.Website.Domain,
    Url: state.Website.Url,
    Title: state.Website.Title,
    Robots: state.Website.Robots,
    MetaData: state.Website.MetaData
  };
}

export default connect(mapStateToProps)(SideBanners);
